/**
 * Created by jonas on 2021-02-19.
 */
import {Loner} from "../Loner";
import {LonerSymbolStates, SYMBOL_NAMES, SymbolPositionData} from "../../core/reel/ReelInterfaces";
import {LonerSymbol} from "../reels/symbols/main/LonerSymbol";


export class SymbolUtils {

    public static getSymbol(isStopping:boolean, symbolName:string, state:LonerSymbolStates, symbolPositionData:SymbolPositionData):LonerSymbol {
        //Don't use pooled symbols with animations during spin
        if(isStopping == true || Loner.model.isRestore == true) {
            if(symbolName == SYMBOL_NAMES.S) {
                if(symbolPositionData.targetPosition > 2 && symbolPositionData.targetPosition < 6) {
                    //Only get scatter from pool if scatter lands on visible reel area
                    return Loner.scatterPool.getSymbol(symbolName, symbolPositionData).init(state);
                } else {
                    return Loner.symbolsPool.getSymbol(symbolName, symbolPositionData).init(state);
                }
            }
            if(symbolName == SYMBOL_NAMES.wild2X2) {
                //Only get scatter from pool if scatter lands on visible reel area
                return Loner.wildSymbolPool.getWild2x2PresentationSymbol(symbolName, symbolPositionData).init(state);
            }
            if(symbolName == SYMBOL_NAMES.wild3X3) {
                //Only get scatter from pool if scatter lands on visible reel area
                return Loner.wildSymbolPool.getWild3x3PresentationSymbol(symbolName, symbolPositionData).init(state);
            }
            return Loner.symbolsPool.getSymbol(symbolName, symbolPositionData).init(state);
        }
        if(symbolName == SYMBOL_NAMES.wild2X2) {
            return Loner.wildSymbolPool.getWild2x2Symbol(symbolName, symbolPositionData).init(state);
        }
        if(symbolName == SYMBOL_NAMES.wild3X3) {
            return Loner.wildSymbolPool.getWild3x3Symbol(symbolName, symbolPositionData).init(state);
        }

        return Loner.symbolsPool.getSymbol(symbolName, symbolPositionData).init(state);
    }
}